import "./src/index.css";
import type { GatsbyBrowser } from "gatsby";

export const onClientEntry: GatsbyBrowser["onClientEntry"] = () => {
  // Any browser-only initialization
};

export const onRouteUpdate: GatsbyBrowser["onRouteUpdate"] = ({ location, prevLocation }) => {
  // Push route change to dataLayer for GTM
  // This ensures SPA navigation is tracked properly
  if (typeof window !== "undefined" && window.dataLayer) {
    // Only push if the route actually changed
    if (!prevLocation || prevLocation.pathname !== location.pathname) {
      window.dataLayer.push({
        event: "gatsby-route-change",
        page: {
          path: location.pathname,
          search: location.search,
          hash: location.hash,
          url: location.href,
        },
      });
    }
  }
};

export const wrapRootElement: GatsbyBrowser["wrapRootElement"] = ({ element }) => {
  return element;
};
